import React, { useState } from "react";

import { dataBR } from "../lib/historico";
import { reais } from "../lib/numeros";
import { sigla } from "../lib/unidades";

// Preço por unidade de estoque nas últimas compras (mais antiga → mais nova), com a linha da média.
export default function GraficoPrecos({ compras, media, unit }) {
  const [foco, setFoco] = useState(null);
  const serie = compras.slice(0, 10).reverse();
  if (serie.length < 2) return null;
  const maior = Math.max(...serie.map((c) => c.unitario), media || 0) || 1;
  const altura = (v) => `${Math.max(6, (v / maior) * 100)}%`;
  const destaque = foco ?? serie.length - 1;
  const atual = serie[destaque];

  return (
    <div data-e2e="grafico-precos">
      <div className="mb-2 flex items-baseline justify-between gap-2">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">Preço (últimas {serie.length})</p>
        <p className="text-xs tabular-nums text-muted-foreground"><b className="text-foreground">{reais(atual.unitario)}</b> · {dataBR(atual.data).slice(0, 5)}</p>
      </div>
      <div className="relative h-24 flex items-end gap-1" onMouseLeave={() => setFoco(null)}>
        {media > 0 && (
          <div className="absolute inset-x-0 border-t border-dashed border-primary/60 pointer-events-none" style={{ bottom: altura(media) }}>
            <span className="absolute right-0 -top-4 text-[10px] text-primary font-medium">média</span>
          </div>
        )}
        {serie.map((c, n) => (
          <button key={c.id || n} type="button" onMouseEnter={() => setFoco(n)} onFocus={() => setFoco(n)} onClick={() => setFoco(n)}
            title={`${dataBR(c.data)} · ${reais(c.unitario)}/${sigla(unit)}`}
            className={`flex-1 rounded-t transition-colors ${n === destaque ? "bg-primary" : "bg-primary/30 hover:bg-primary/50"}`}
            style={{ height: altura(c.unitario) }} />
        ))}
      </div>
      <div className="flex justify-between mt-1 text-[10px] text-muted-foreground tabular-nums">
        <span>{dataBR(serie[0].data).slice(0, 5)}</span>
        <span>{dataBR(serie[serie.length - 1].data).slice(0, 5)}</span>
      </div>
    </div>
  );
}
